import React, { Component } from 'react';
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Footer from '../components/Footer'
import '../css/StoryPage.css';

class StoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      cases: [],
      expandedId: null,
      heroTitle: {
        zh: "客戶成功案例",
        en: "Customer Success Stories",
        ja: "導入事例"
      },
      heroSub: {
        zh: "了解 Nexuni 如何幫助客戶實現 AI 自動化轉型",
        en: "Discover how Nexuni helps customers achieve AI automation transformation",
        ja: "NexuniがどのようにAI自動化変革を支援しているかをご紹介"
      }
    }

    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    updateSEO('stories', this.state.lang, '/stories');
    fetch(process.env.PUBLIC_URL + '/yaml/case_studies.yaml')
      .then(response => response.text())
      .then(text => {
        const parsed = yaml.load(text);
        if (parsed && parsed.cases) {
          this.setState({ cases: parsed.cases });
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  toggleExpand(id) {
    this.setState({ expandedId: this.state.expandedId === id ? null : id });
  }


  render() {
    const lang = this.state.lang;
    const detailLabels = {
      challenge: { zh: "挑戰", en: "Challenge", ja: "課題" },
      solution: { zh: "解決方案", en: "Solution", ja: "ソリューション" },
      results: { zh: "成果", en: "Results", ja: "成果" }
    };

        return (
          <div className={"story_page " + lang}>
            <AnnouncementBanner lang={lang} />
            <Navbar lang={lang} updateLangFunc={this.update_lang} />
            <Breadcrumb lang={lang} items={[{ label: { zh: "客戶案例", en: "Case Studies", ja: "導入事例" } }]} />

            <div className="story_hero">
              <Fade duration={1000} delay={200}>
                <h1>{this.state.heroTitle[lang]}</h1>
                <p>{this.state.heroSub[lang]}</p>
              </Fade>
            </div>

            <div className="story_cases_grid">
              {this.state.cases.map((caseItem, idx) => (
                <Fade duration={800} delay={200 + idx * 100} key={caseItem.id}>
                  <div className={"story_case_card" + (this.state.expandedId === caseItem.id ? " story_expanded" : "")}>
                    <div className="story_case_img" style={{backgroundImage: 'url(' + caseItem.img + ')'}} />
                    <div className="story_case_body">
                      <span className="story_case_industry">{caseItem.industry[lang]}</span>
                      <h3 className="story_case_customer">{caseItem.customer[lang]}</h3>
                      <div className="story_case_metrics">
                        {caseItem.metrics.map((m, midx) => (
                          <div key={midx} className="story_metric">
                            <span className="story_metric_value">{m.value}</span>
                            <span className="story_metric_label">{m.label[lang]}</span>
                          </div>
                        ))}
                      </div>
                      <button className="story_case_toggle" onClick={() => this.toggleExpand(caseItem.id)}>
                        {this.state.expandedId === caseItem.id
                          ? (lang === 'zh' ? '收起' : lang === 'ja' ? '閉じる' : 'Collapse')
                          : (lang === 'zh' ? '查看詳情' : lang === 'ja' ? '詳細を見る' : 'View Details')}
                      </button>
                      {this.state.expandedId === caseItem.id && (
                        <div className="story_case_details">
                          <div className="story_detail_item">
                            <h4>{detailLabels.challenge[lang]}</h4>
                            <p>{caseItem.challenge[lang]}</p>
                          </div>
                          <div className="story_detail_item">
                            <h4>{detailLabels.solution[lang]}</h4>
                            <p>{caseItem.solution[lang]}</p>
                          </div>
                          <div className="story_detail_item">
                            <h4>{detailLabels.results[lang]}</h4>
                            <p>{caseItem.results[lang]}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Fade>
              ))}
            </div>

            <Footer lang={lang} navigate={this.navigate}/>
          </div>
        )
  }

}

export default StoryPage;
